(function() {
    'use strict';

    angular.module('app.impuestosRenta', []);
})();
